import apiManagerUser from 'api/manager-users'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { endSession as logout } from 'store/sessionSlice'
import { clearConfirmRefreshTimer } from 'services/sessionTimerService'

export const useHandlerUser = () => {
    const dispatch = useDispatch()
    
    const handleStopSharingInfo = async () => {
        try {
            await apiManagerUser.updateStatusSharingInfo({
                status: 0
            })
        } catch (error) {
            console.log('Error', error)
        }
    }

    const handleLogout = async _ => {
        // await apiManagerUser.logout()
        toast.dismiss()
        setTimeout(() => {
            clearConfirmRefreshTimer()
            dispatch(logout())
            localStorage.setItem("checkEventPopupByUser", 0);
        }, 1000);
    }

    const handleRejectShare = async (callback) => {
        await handleStopSharingInfo()
        await handleLogout()
        
        try {
            if(callback) callback()
        } catch (error) {
            console.log('Error: ', error)
        }
    }

    return {
        handleLogout,
        handleRejectShare
    }
}
